import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";

interface Props
{
    energy: number;
}

import './BatteryIndicator.scss';

export default class BatteryIndicator extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {energy} = this.props;
        const battery_fill_width: string = (energy / 100 / 0.01) +'%';



        return <div styleName={'battery'}>

            <div
                styleName={'battery-fill'}
                style={{ width: battery_fill_width }}/>

            <div styleName={'energy-icon'}/>

        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/ts/app/screens/mini-game/BatteryIndicator.tsx